'use client';
/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import {
  ArrowForwardIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@chakra-ui/icons';
import { Link } from '@chakra-ui/next-js';
import { Box, Center, Text } from '@chakra-ui/react';

import { RxCross2 } from 'react-icons/rx';
import Slider from 'react-slick';
/* Internal Imports */
/* Components */
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';

/* Services */
/* Styles */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const FeaturedProductions = ({ sectionContent }) => {
  const [activeCard, setActiveCard] = useState(null);

  const NextArrow = props => {
    const { onClick } = props;
    return (
      <Box
        as="button"
        onClick={onClick}
        position="absolute"
        top="105%"
        // right="46.5%"
        right={{ base: 'calc(50% - 30px)', '2xl': 'calc(50% - -80px)' }}
        zIndex={1000}
        // width="6rem"
        // height="3rem"
        // overflow="visible" /* Change overflow to visible temporarily */
        // display={{ lg: 'flex', base: 'none' }}
        alignItems="center"
        justifyContent="center"
        background="#000"
        color="#fff"
        fontSize="24px"
        borderRadius="0px 16px 16px 0px"
        cursor="pointer"
        padding="0"
      >
        <ChevronRightIcon />
      </Box>
    );
  };

  const PrevArrow = props => {
    const { onClick } = props;
    return (
      <Box
        as="button"
        onClick={onClick}
        position="absolute"
        top="105%"
        // left={{ md: '47%', '2xl': '47.5%' }}
        left={{ base: 'calc(50% - 30px)', '2xl': 'calc(50% - 150px)' }}
        background="#000"
        color="#fff"
        fontSize="24px"
        borderRadius="16px 0px 0px 16px"
        zIndex={1000}
        // width="5rem"
        // height="3rem"
        // overflow="visible" /* Change overflow to visible temporarily */
        // display={{ lg: 'flex', base: 'none' }}
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        padding="0"
      >
        <ChevronLeftIcon />
      </Box>
    );
  };

  const sliderSettings = {
    // dots: true,
    className: 'featuredSlider',
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: true,
    centerMode: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    className: 'FeaturedProd',
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const titleData = sectionContent[0] || {};
  const cards = sectionContent[1]?.cards || [];

  const handleCardClick = index => {
    setActiveCard(index === activeCard ? null : index);
  };

  return (
    <Box
      width={'100%'}
      position={'relative'}
      // bg={'black'}
      paddingTop={{ base: '6rem', md: '5rem' }}
      // mb={{ base: '2rem', md: '0' }}
      // mb={{ base: '-14rem', md: '0' }}
      zIndex="5"
      _after={{
        content: "''",
        pos: 'absolute',
        display: { base: 'block', md: 'none' },
        bottom: -20,
        left: 0,
        right: 0,
        width: '100%',
        height: 210,
        background: '#FEFAF6',
        zIndex: -1,
      }}
    >
      <Box
        display={'flex'}
        px="16px"
        flexDirection={{ base: 'column', md: 'row' }}
        gap={{ md: '4' }}
        justifyContent={{ base: 'space-between' }}
        alignItems={{ md: 'center' }}
        // mx={{ base: '1rem', lg: '5rem' }}
        w="100%"
        maxW={{ xl: 1170, '2xl': 1470 }}
        mx="auto"
      >
        <Box
          display={{ base: 'flex' }}
          textAlign={{ base: 'left' }}
          flexDirection={{ base: 'column', md: 'row' }}
          gap={{ base: '.2rem', md: '.5rem' }}
          letterSpacing={'0.16px'}
          lineHeight={'120%'}
          fontSize={{ base: '1.5rem', md: '2.25rem' }}
        >
          <Text color={'white'} fontFamily={'var(--FedraSerifDisplay-Regular)'}>
            {titleData.titleText}
          </Text>
          <Text fontFamily={'var(--FedraSerifDisplay-Bold)'} color={'#F18128'}>
            {titleData.titleSubtext}
          </Text>
        </Box>
        {sectionContent[2]?.linkUrl && (
          <Link
            href={refineUrlDomain(sectionContent[2]?.linkUrl)}
            _active={{ boxShadow: 'none' }}
            prefetch
          >
            <Text
              fontSize={{ md: '16px' }}
              fontFamily="var(--FedraSansStd-book)"
              fontWeight={500}
              lineHeight={{ md: '25.6px' }}
              mr="5px"
              mb={2}
              display={{ base: 'none', md: 'block' }}
              color={'#F18128'}
            >
              {sectionContent[2]?.buttonText}
              <ArrowForwardIcon ml="5px" boxSize={5} mb={0.5} />
            </Text>
          </Link>
        )}
        <Center
          ml="5px"
          boxSize="48px"
          borderRadius="full"
          bg="rgba(96, 173, 255, 0.2)"
          display={{ base: 'flex', md: 'none' }}
          position="absolute"
          right="4"
        >
          <Link href={refineUrlDomain(sectionContent[2]?.linkUrl)} prefetch>
            <ArrowForwardIcon boxSize="24px" color={'#F18128'} />
          </Link>
        </Center>
      </Box>

      <Box
        className="slider-container"
        marginTop={{ base: '16px', md: '32px' }}
        // css={{
        //   '.slick-slide': {
        //     margin: '0 10px !important',
        //     width: '50vw',
        //     '@media (max-width: 576px)': {
        //       width: '80vw',
        //     },
        //     boxSizing: 'border-box',
        //   },
        //   '.slick-list': {
        //     margin: '0 -10px !important',
        //   },
        // }}
        sx={{
          '.FeaturedProd .slick-dots li button:before': {
            fontSize: '12px',
          },
        }}
        width={{ base: '100%', lg: '90%', '2xl': '88%' }}
        ml="auto"
        maxHeight={{ base: '400px', md: '550px', lg: '800px' }}
        pl={{ base: '16px', lg: '0' }}
        // overflow={'hidden'}
      >
        <Slider {...sliderSettings}>
          {cards.map((card, index) => (
            <Box
              mr={{ base: '20px', md: '30px', '2xl': '46px' }}
              w={{
                base: '299px !important',
                lg: '500px !important',
                xl: '670px !important',
                '2xl': '713px !important',
              }}
            >
              <Box
                key={index}
                pr="10px"
                height={{ base: '338px', md: '500px', lg: '753px' }}
                backgroundImage={`url(${card.thumbnail.url})`}
                backgroundSize="cover"
                backgroundPosition="center"
                position="relative"
                mt={{ base: '2rem' }}
              >
                <Box
                  display={'flex'}
                  flexDirection="row"
                  justifyContent={{ base: 'space-between' }}
                  alignItems={{ base: 'center' }}
                  padding={{ base: '1rem', md: '2rem' }}
                  minHeight={{
                    lg: '250px',
                    xl: '200px',
                    md: '225px',
                    base: '110px',
                  }}
                  maxHeight={{ lg: '753px', xl: '500px' }}
                  position="absolute"
                  // border={'2px solid red'}
                  left="0"
                  right="0"
                  bottom={0}
                  bgColor={'rgba(1, 5, 9, 0.7)'}
                >
                  <Box
                    color={'#FEFAF6'}
                    letterSpacing={'0.32px'}
                    lineHeight={'160%'}
                  >
                    <Text
                      fontFamily={'var(--FedraSansStd-medium)'}
                      fontWeight={'medium'}
                      fontSize={{ base: '1.125rem', md: '1.5rem' }}
                    >
                      {card.title}
                    </Text>
                    <Text
                      mt={{ base: '0', md: '0.5rem' }}
                      fontFamily={'var(--FedraSansStd-book)'}
                      opacity={'0.6'}
                      fontSize={{ base: '0.875rem', md: '1.125rem' }}
                    >
                      {card.buttonText}
                    </Text>
                    {activeCard === index && (
                      <Text
                        maxH={{ base: 155, md: 'none' }}
                        overflowY="auto"
                        h="auto"
                        fontFamily={'var(--FedraSansStd-book)'}
                        fontSize={{ base: '14px', md: '1rem' }}
                        mt={2}
                      >
                        {
                          card.description.value.document.children[0]
                            .children[0].value
                        }
                      </Text>
                    )}
                  </Box>

                  <Center
                    pos="absolute"
                    top={0}
                    right={0}
                    // ml="5px"
                    padding={
                      activeCard !== index && { base: '.5rem', lg: '1rem' }
                    }
                    // boxSize={{ md: '3rem', '2xl': '3rem', base: '2rem' }}
                    borderRadius={{ base: 'full' }}
                    bg={activeCard === index ? 'transparent' : '#F18128'}
                    _hover={{
                      bg: activeCard === index ? 'transparent' : '#E99654', // Only apply hover color if not active
                    }}
                    position="relative"
                    transform="rotate(270deg)"
                    onClick={() => handleCardClick(index)}
                    cursor="pointer"
                  >
                    {activeCard === index ? (
                      <RxCross2
                        boxSize="40px"
                        color={'#FEFAF6'}
                        style={{
                          marginBottom: '0',
                          width: '2rem',
                          position: 'absolute',
                          left: '4rem',
                          height: '2rem',
                        }}
                      />
                    ) : (
                      <ArrowForwardIcon boxSize="24px" color={'#010509'} />
                    )}
                  </Center>
                </Box>
              </Box>
            </Box>
          ))}
        </Slider>
        <style>
          {`
          .featuredSlider .slick-dots li button:hover:before, .slick-dots li button:focus:before{
          opacity:0.25;
          }
          `}
        </style>
      </Box>
    </Box>
  );
};

export default FeaturedProductions;
